<template>
  <div class="list-container">
    <!-- Organization and Channel Tabs -->
    <OrganizationChannelTabs
      ref="organizationChannelTabs"
      @organization-selected="onOrganizationSelected"
      @channel-selected="onChannelSelected"
    />

    <!-- Videos List -->
    <div class="list-header">
      <h1>Video List</h1>

      <router-link
        v-if="selectedChannel && canCreateVideo(selectedOrganization.id)"
        :to="`/channels/${selectedChannel.id}/videos/new`"
        class="important-button big"
      >
        <font-awesome-icon icon="plus" /> Publish Video
      </router-link>
    </div>

    <VideoList 
      v-if="selectedChannel" 
      :channelId="selectedChannel?.id"
      :organizationId="selectedOrganization?.id"
    />
    <div v-else-if="selectedOrganization && !organizationChannelTabs?.isLoadingChannels" class="message">
      Your organization needs a channel to manage videos.
    </div>
    <div v-else-if="!selectedOrganization && !organizationChannelTabs?.isLoadingOrganizations" class="message">
      <div>
        You need to be a member of an organization to see videos.
      </div>
      <NewOrganizationButton />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import VideoList from '@/components/VideoList.vue';
import OrganizationChannelTabs from '@/components/OrganizationChannelTabs.vue';
import { canCreateVideo } from '@/scripts/permissions';
import NewOrganizationButton from '@/components/NewOrganizationButton.vue';

const organizationChannelTabs = ref(null);
const selectedOrganization = ref(null);
const selectedChannel = ref(null);

// Handler for organization selection
const onOrganizationSelected = (organization) => {
  selectedOrganization.value = organization;
};

// Handler for channel selection
const onChannelSelected = (channel) => {
  selectedChannel.value = channel;
};
</script>

<style scoped>
@import '@/styles/shared-list.css';
@import '@/styles/shared-tabs.css';
</style>
